import React, { Component } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator';
import { Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import LoadingModal from "../../components/modal/LoadingModal";
import NewCustomerModal from "./components/NewCustomerModal";
import { getCustomerList } from '../../resources/API';
import moment from 'moment';
import Filter from "./components/Filter";

const DATEDIFF = 360;
const DATEDIFF_EXPORT = 30;
const defaultFilterCriteria = {
  merchantId: "",
  merchantName: "",
  bankAccount:"",
  userId:"",
  currencyName:"",
  tableFilter: {
      page : 1,
      sizePerPage : 25,
      sortOrder : "desc",
      sortField : "dummy"
  }
};

class CustomerProfileTable extends Component {

  constructor(props) {
    super();
    defaultFilterCriteria.merchantId = props.merchantProfile.merchantId;
    const filterCriteria = props.location && props.location.state ?
                                props.location.state.filterCriteria :
                                {...defaultFilterCriteria};

    const tableHeader = [
      { text: "Id", dataField: "custProfileId", sort: true, hidden:true },
      // { text: "Merchant ID", dataField: "merchantId", sort: true },
      // { text: "Merchant Name", dataField: "merchantName", sort: true },
      { text: "Customer Account No.", dataField: "bankAccount", sort: true },
      { text: "Customer Name", dataField: "fullName", sort: true},
      { text: "User ID", dataField: "userId", sort: true, headerStyle: { width: '140px'} },
      { text: "Payment Channel", dataField: "customerPaymentChannel", sort: true },
      { text: "Status", dataField: "isActive", sort: true, align:'center',headerAlign:'center',headerStyle: { width: '80px'}},
      { text: "Approval Status", dataField: "isPendingApproval", sort: true, align:'center',headerAlign:'center', }
    ];

    this.state = {
      filterCriteria: {...filterCriteria},
      searchedCriteria: {...filterCriteria},
      tableHeader: tableHeader,
      tableBody: [],
      tableCount : 0,
      loadingShow: false,
      newCustModalShow: false      
    }
  }

  handleFilterCriteriaSubmit = () => {
    const { filterCriteria } = this.state;
    this.getData(filterCriteria);
    this.setState({
        searchedCriteria: {...filterCriteria}
    });
}

  handleTableChange = (type, props) => {
    const {searchedCriteria} = this.state;
        const tableChangeCriteria = {...searchedCriteria,
                                        tableFilter: {
                                            page : props.page,
                                            sizePerPage : props.sizePerPage,
                                            sortOrder : props.sortOrder,
                                            sortField : props.sortField
                                        }
                                    };
        this.getData(tableChangeCriteria);
        this.setState({
            searchedCriteria: {...tableChangeCriteria}
        });
  }

  handleRefresh = () => {
    this.getData(this.state.searchedCriteria);
  }

  handleFilterCriteriaChange = (e) => {
    let { name, value } = e.target;
    let currentState = this.state.filterCriteria;
    currentState[name] = value;

    this.setState({
        filterCriteria: currentState
    });
}

  handleFilterCriteriaReset = () => {
    this.setState({
      filterCriteria: {...defaultFilterCriteria}
    });
  }

  getData = async (criteria) => {
    this.setState({loadingShow : true});
      const {accessToken} = this.props;
      const customerListResponse = await getCustomerList(criteria, accessToken);
      if((customerListResponse && customerListResponse.status === 200)){
          const customerList = customerListResponse.body.customerProfilePaging.customerProfileWebViewList;
          const tableCount = customerListResponse.body.customerProfilePaging.totalSize;
          const tableBody = customerList.map((customer) => {
            const customerLink = "/customer/view/" + customer.custProfileId;
            return {
                custProfileId : customer.custProfileId,
                merchantId : customer.merchantId,
                merchantName : customer.merchantName,
                fullName : customer.fullName,
                bankAccount : <Link to={{
                                pathname:customerLink,
                                state:{
                                  role: this.props.role,
                                  filterCriteria: this.state.searchedCriteria,
                                  accessToken: this.props.accessToken,
                                  username: this.props.username,
                                  type: customer.customerType,
                                  custProfileId: customer.custProfileId
                                  }
                                }}>
                              {customer.bankAccts[0]}
                            </Link>,
                userId : customer.userId,
                updateDatetime : moment(customer.updateDatetime,"YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm:ss"),
                customerRegisterChannel : customer.customerRegisterChannel,
                customerPaymentChannel : customer.customerPaymentChannel,
                isActive : customer.isActive === "Y" ? 
                                  <Badge pill variant="success">ACTIVE</Badge>: 
                                  <Badge pill variant="secondary">INACTIVE</Badge>,
                isPendingApproval : customer.isPendingApproval === "Y"?
                        <Badge variant="warning">PENDING APPROVAL</Badge>: ""
              }
          });
          this.setState({
            tableBody : tableBody,
            tableCount : tableCount
          });
      }
      this.setState({loadingShow : false});
  }

  render() {
    const { role, accessToken, username} = this.props;
    const { loadingShow, newCustModalShow, tableHeader, tableBody, filterCriteria, searchedCriteria, tableCount } = this.state;

    const defaultSorted = [{
      dataField: searchedCriteria.tableFilter.sortField, // if dataField is not match to any column you defined, it will be ignored.
      order: searchedCriteria.tableFilter.sortOrder // desc or asc
    }];
    const options = {
      custom: true,
      sizePerPage:searchedCriteria.tableFilter.sizePerPage,
      page:searchedCriteria.tableFilter.page,
      totalSize: tableCount,
      sizePerPageList: [{
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }, {
        text: '75', value: 75
      }, {
        text: '100', value: 100
      }],
      alwaysShowAllBtns: true,
      firstPageText: 'First',
      prePageText: 'Prev',
      nextPageText: 'Next',
      lastPageText: 'Last'
    };
    return (
      <React.Fragment>
        <PaginationProvider pagination={paginationFactory(options)}>
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="custProfileId"
              data={tableBody}
              columns={tableHeader}
              search
            >
              {toolkitprops => {
                return (
                  <Card className="shadow mt-4 mx-auto card-width-1200">
                    <Card.Header className="pt-3 pb-2 bg-white">
                      <Row>
                        <Col sm={12} className="text-scb font-weight-bold">
                          Customer Profile
                        </Col>
                      </Row>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col sm={10}>
                          <Filter
                            criteria={filterCriteria}
                            onSubmit={this.handleFilterCriteriaSubmit}
                            onChange={this.handleFilterCriteriaChange}
                            onReset={this.handleFilterCriteriaReset}
                            onTableChange = {this.handleTableChange}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <BootstrapTable
                            hover
                            striped
                            bordered={false}
                            defaultSorted={defaultSorted}
                            noDataIndication={"No data found"}
                            {...toolkitprops.baseProps}
                            {...paginationTableProps}
                            remote={ {
                              filter: true,
                              pagination: true,
                              sort: true,
                              cellEdit: false
                            } }
                            onTableChange={ this.handleTableChange }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={"auto"} className="mr-auto">
                          <span className="mr-1">Display</span>
                          <SizePerPageDropdownStandalone btnContextual="btn-scb" {...paginationProps} />
                          <span className="ml-1 mr-1">records per page.</span>
                          <PaginationTotalStandalone {...paginationProps} />
                        </Col>
                        <Col sm={"auto"}>
                          <PaginationListStandalone {...paginationProps} />
                        </Col>
                      </Row>

                    </Card.Body>
                  </Card>
                )
              }}
            </ToolkitProvider>
          )}
        </PaginationProvider>
        <LoadingModal show={loadingShow} />
        <NewCustomerModal 
          state={{
            role: role,
            filterCriteria: searchedCriteria,
            accessToken: accessToken,
            username: username
          }}
          show={newCustModalShow} 
          onClose={() => {this.setState({newCustModalShow : false})}}
        />
      </React.Fragment>
    );
  }
}

export default CustomerProfileTable;